import {Spine} from 'pixi-spine';

export default class DrawingSpine extends Spine {
    constructor(spineData, name = null) {
        super(spineData);

        this._name = name;
        this._hacks = {};
    }

    destroy() {
        super.destroy({children: true});
    }

    deleteHacks() {
        for (const i in this._hacks) {
            if (this._hacks.hasOwnProperty(i)) {
                const hack = this._hacks[i];
                hack.destroy();
            }
        }
    }

    update(dt) {
        super.update(dt);
    }

    addTextureHack(hack) {
        const frame = hack.frames[0];
        hack.texture = frame.texture;
        this.hackTextureBySlotName(hack.slotName, frame.texture, frame.texture.orig);
        this.setSlotAnchor(hack.slotName, frame.anchor.x, frame.anchor.y);
        this._hacks[hack.slotName] = hack;
    }

    setSlotAnchor(slotName, x, y) {
        const slot = this.skeleton.findSlot(slotName);
        slot.currentSprite && slot.currentSprite.anchor.set(x, y);
    }

    get hacks() {
        return this._hacks;
    }

    get name() {
        return this._name;
    }
}